import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const SettingsLoader = () => {
  return (
    <div className="grid grid-cols-4 gap-4">
      <Skeleton height={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={320} baseColor={brandColors.lightSilver} />
      <Skeleton height={320} baseColor={brandColors.lightSilver} />
    </div>
  );
};

export default SettingsLoader;
